/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const featureFlagNestedNameMax = 255;

export const featureFlagNestedCodeMax = 255;

export const FeatureFlagNested = zod.strictObject({
    name: zod.string().max(featureFlagNestedNameMax),
    code: zod.string().max(featureFlagNestedCodeMax),
});

export type FeatureFlagNested = zod.input<typeof FeatureFlagNested>;
export type FeatureFlagNestedOutput = zod.output<typeof FeatureFlagNested>;
